import styled from 'styled-components'
import { TituloH1 as TituloPrincipal, Sorriso as IconSorriso, Descricao } from '../../../../components/TituloSorriso/styles'
import { media } from '../../../../layouts/utils'

export const TextContainer = styled.div`
  text-align: center;
`

/**
 * export const Title = styled(TituloPrincipal)`
  color: ${colorBrandPrimary.turquoise};
  padding-top: 10px;
`
 */

export const Sorriso = styled(IconSorriso)`
  margin-bottom: 0;
`

export const TextWrap = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  flex-direction: column;
`

export const Title = styled(TituloPrincipal)`
  ${media.desktop`
    max-width: 100%;
    line-height: 28px;
    font-size: 32px;
    `}
  font-size: 48px;
  padding: 0;
  text-align: center;
  max-width: 300px;
  margin-bottom: 10px;
  line-height: 45px;
`

export const Text = styled(Descricao)`
  ${media.phone`
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
  `}
  padding: 0;
  text-align: center;
  margin-top: 16px;
`
